/* How many API requests are in flight right now — lets a screen wait until
   everything it asked for has arrived (the business-switch cover does).

   Each attempt gets its own id: a request retried after a token refresh
   goes out again with a copy of the same config, and must not be counted
   as finished by the first attempt's failure. Install BEFORE any other
   interceptor, so this response handler sees every attempt settle before
   another handler turns a failure into a retry. */

const open = new Set();
let seq = 0;

const emit = () => window.dispatchEvent(new Event("rf:net"));

export const pendingRequests = () => open.size;

export function installNetActivity(axios) {
  axios.interceptors.request.use((config) => {
    seq += 1;
    config.__rfNetId = seq;
    open.add(seq);
    emit();
    return config;
  });

  const settle = (config) => {
    if (config && open.delete(config.__rfNetId)) emit();
  };
  axios.interceptors.response.use(
    (response) => {
      settle(response && response.config);
      return response;
    },
    (error) => {
      settle(error && error.config);
      return Promise.reject(error);
    }
  );
}
